export interface PartnerDisplayNameSource {
  name?: string | null;
  surName?: string | null;
}

function normalizeNamePart(value: string | null | undefined): string {
  return (value ?? '').trim().replace(/\s+/g, ' ');
}

export function getPartnerDisplayName(
  partnerOrName: PartnerDisplayNameSource | string | null | undefined,
  surName?: string | null,
): string {
  const name = typeof partnerOrName === 'string'
    ? normalizeNamePart(partnerOrName)
    : normalizeNamePart(partnerOrName?.name);
  const surname = typeof partnerOrName === 'string'
    ? normalizeNamePart(surName)
    : normalizeNamePart(partnerOrName?.surName);

  if (!name) return surname;
  if (!surname) return name;
  return name === surname ? name : `${name} ${surname}`;
}
